import { FC } from 'react';

import styles from './index.module.scss';

type Props = {
	onClick: (symbol: string) => void;
	selected: string;
	available: string[];
};

/**
 * These "symbols" represent a list of all alphanumeric characters
 * and appear as a navbar/menu with clickable buttons which, when clicked,
 * will scroll the list of Sources/Forwarders to the first element which has
 * its first letter of the "name_long" attribute matching the clicked "symbol".
 */
const symbols = 'abcdefghijklmnopqrstuvwxyz0123456789'.split('');

export const Symbols: FC<Readonly<Props>> = ({ onClick, selected, available }) => (
	<ul className={styles.symbols} data-testid="symbols">
		{symbols.map(symbol => (
			<li key={symbol}>
				<button
					type="button"
					onClick={() => onClick(symbol)}
					disabled={available.indexOf(symbol) === -1}
					className={selected === symbol ? styles.active : undefined}
				>
					{symbol}
				</button>
			</li>
		))}
	</ul>
);

export default Symbols;
